import React from 'react';

import { MixPanelTrackedLink } from './MixPaneTrackedLink';

export function DefaultAmountCard({ currency, handleDefaultAmountSelect, donationAmount }) {
    return <MixPanelTrackedLink
        key={currency.id}
        id="defaultAmount"
        name="donationAmount"
        variant={currency.default_value == donationAmount ? 'contained' : 'outlined'}
        sx={{
            borderColor: '#C8C8C8',
            color: currency.default_value == donationAmount ? null : '#495057',
        }}
        value={currency.default_value.toLocaleString()}
        onClick={handleDefaultAmountSelect}
        type="button"
        context="Default amount option on checkout page"
        label={`${currency.default_value.toLocaleString()}`}
        fullWidth
    >
        {currency.default_value.toLocaleString()}
    </MixPanelTrackedLink>
}